export { AffineFormatBarWidget } from './format-bar.js';
